import {
  PlanCardContainer, PlanCardTopContainer, PlanCardDetailsContainer, PlanCardName, PlanCardPrice,
  PlanCardRecommendation, PlanCardRecommendationSize, PlanCardImg, PlanCardBottomContainer,
  PlanCardFeatureSize, PlanCardFeatureDescription, PlanCardActivePlan, PlanCardActivePlanText
} from "components/common/PlanCard/PlanCard.styles";
import {useAppSelector} from "store/hooks";
import {CarouselIndexes} from "components/carousel/Carousel";
import {useDispatch} from "react-redux";
import {updateSubscriptionPlan} from "store/ui/subscriptionPlan/subscriptionPlan.slice";
import {useNavigate} from "react-router-dom";

interface PlanCardProps {
  planJson: BenevPlan,
  setChosenPlan?: (plan: BenevPlan) => void,
  setShowCheckout?: (display: boolean) => void,
  setShowLogin?: (display: boolean) => void,
  index?: number,
  handleLeftIndexes?: () => void,
  handleRightIndexes?: () => void,
  indexes?: CarouselIndexes
}

function PlanCard(props: PlanCardProps) {
  const {planJson, index, indexes, handleLeftIndexes, handleRightIndexes} = props;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // handles animation of cards when clicking, uses else-if to ensure only one runs upon click
  const handleAnimation = () => {
    if (index! === indexes!.nextIndex) handleRightIndexes!();
    else if (index! === indexes!.previousIndex) handleLeftIndexes!();
  }

  const selectPlan = () => {
    dispatch(updateSubscriptionPlan(planJson));
    navigate('/checkout')
  }

  // if there's indexes, then use card for animations when choosing plans
  if (handleLeftIndexes && indexes) {
    return (
      <PlanCardContainer index={index} indexes={indexes} onClick={handleAnimation}>
        <PlanCardTopContainer>
          <PlanCardDetailsContainer>
            <PlanCardName> {planJson.name} </PlanCardName>
            <PlanCardPrice> {formatter.format(planJson.price / 100)} / month </PlanCardPrice>
            <PlanCardRecommendation> {planJson.recommendationType} </PlanCardRecommendation>
            <PlanCardRecommendationSize> {planJson.recommendationSize} </PlanCardRecommendationSize>
          </PlanCardDetailsContainer>

          <PlanCardImg src={planJson.image}/>
        </PlanCardTopContainer>

        <PlanCardBottomContainer>
          <PlanCardFeatureSize> {planJson.featureSize} </PlanCardFeatureSize>
          <PlanCardFeatureDescription> {planJson.featureDescription} </PlanCardFeatureDescription>
          <PlanCardActivePlan isActive={index === indexes.currentIndex} onClick={selectPlan}>
            <PlanCardActivePlanText> Select Plan </PlanCardActivePlanText>
          </PlanCardActivePlan>
        </PlanCardBottomContainer>
      </PlanCardContainer>
    )
  }

  // the actual card component with no indexes attached
  return (
    <PlanCardContainer>
      <PlanCardTopContainer>
        <PlanCardDetailsContainer>
          <PlanCardName> {planJson.name} </PlanCardName>
          <PlanCardPrice> {formatter.format(planJson.price / 100)} / month </PlanCardPrice>
          <PlanCardRecommendation> {planJson.recommendationType} </PlanCardRecommendation>
          <PlanCardRecommendationSize> {planJson.recommendationSize} </PlanCardRecommendationSize>
        </PlanCardDetailsContainer>

        <PlanCardImg src={planJson.image}/>
      </PlanCardTopContainer>

      <PlanCardBottomContainer>
        <PlanCardFeatureSize> {planJson.featureSize} </PlanCardFeatureSize>
        <PlanCardFeatureDescription> {planJson.featureDescription} </PlanCardFeatureDescription>
      </PlanCardBottomContainer>

    </PlanCardContainer>
  )
}

export default PlanCard;
